module.exports = __webpack_public_path__ + "img/restaurant_1_truck.2e626675.jpeg";